module.exports = __webpack_public_path__ + "images/1262fdffe0c2dc08d524220e27349028.png";